/**
 * "Tesouraria e bancos" section copy (ALC-4590), plus the copy the shared treasury detail uses
 * under every TR row. The rows are advisory: they never count toward the checklist progress and
 * never block the close; the bank checklist item keeps its own (non-blocking) status.
 */
export const trSectionPtBr = {
  title: 'Tesouraria e bancos',
  subtitle:
    'Controles consultivos, fora do progresso do checklist. Diagnosticam extratos, conciliações e lançamentos; não importam, conciliam nem lançam nada.',
};

export const trSectionEn: typeof trSectionPtBr = {
  title: 'Treasury and banks',
  subtitle:
    'Advisory controls, outside the checklist progress. They diagnose statements, reconciliations and postings; they never import, reconcile or post anything.',
};

export const treasuryDetailPtBr = {
  openMovement: 'Revisar movimento',
  openReconciliation: 'Abrir conciliação',
  openCounterpart: 'Abrir contrapartida',
  age_one: 'há {{count}} dia',
  age_other: 'há {{count}} dias',
  otherReason: 'Outras pendências',
  observationFallback: '{{code}}: {{count}}',
  truncated:
    'Mostrando {{shown}} de {{count}} pendências. Os totais por grupo só aparecem quando a lista cabe inteira.',
  unjudged: {
    title: 'Movimentos não avaliados',
    NO_RECONCILIATION_GROUP: 'Conciliado sem grupo de conciliação',
    UNSUPPORTED_TARGET: 'Conciliado com {{value}}, sem evidência de lançamento suportada',
    INTERNAL_OPERATION: 'Operação interna de tipo {{value}}',
    TAX_JURISDICTION: 'Imposto de aplicação fora da jurisdição brasileira ({{value}})',
    AMOUNT_BASIS:
      'Valor não comparado ao lançamento: moeda do movimento fora da moeda funcional do livro ({{value}})',
    other: 'Não avaliado ({{value}})',
  },
  accounts: {
    title: 'Contas conhecidas',
    latestStatement: 'Último extrato: {{date}}',
    noStatement: 'Sem dados de extrato',
    integrated: 'Integração diária',
    manual: 'Extrato manual',
    movements: '{{reconciled}} de {{count}} movimentos conciliados',
    closed: 'Extrato fechado',
    open: 'Extrato aberto',
    inactive: 'Inativa',
    sources: {
      USER_DECLARED: 'Saldo informado',
      STATEMENT_CLOSING: 'Saldo final do extrato',
      DAILY_BALANCE: 'Saldo diário',
      LAST_TRANSACTION_BALANCE: 'Saldo do último movimento',
    },
  },
};

export const treasuryDetailEn: typeof treasuryDetailPtBr = {
  openMovement: 'Review movement',
  openReconciliation: 'Open reconciliation',
  openCounterpart: 'Open counterpart',
  age_one: '{{count}} day ago',
  age_other: '{{count}} days ago',
  otherReason: 'Other open items',
  observationFallback: '{{code}}: {{count}}',
  truncated:
    'Showing {{shown}} of {{count}} open items. Totals per group only appear when the whole list fits.',
  unjudged: {
    title: 'Movements not evaluated',
    NO_RECONCILIATION_GROUP: 'Reconciled without a reconciliation group',
    UNSUPPORTED_TARGET: 'Reconciled with {{value}}, with no supported posting evidence',
    INTERNAL_OPERATION: 'Internal operation of type {{value}}',
    TAX_JURISDICTION: 'Investment tax outside the Brazilian jurisdiction ({{value}})',
    AMOUNT_BASIS:
      'Amount not compared to the posting: movement currency outside the book functional currency ({{value}})',
    other: 'Not evaluated ({{value}})',
  },
  accounts: {
    title: 'Known accounts',
    latestStatement: 'Latest statement: {{date}}',
    noStatement: 'No statement data',
    integrated: 'Daily integration',
    manual: 'Manual statement',
    movements: '{{reconciled}} of {{count}} movements reconciled',
    closed: 'Statement closed',
    open: 'Statement open',
    inactive: 'Inactive',
    sources: {
      USER_DECLARED: 'Declared balance',
      STATEMENT_CLOSING: 'Statement closing balance',
      DAILY_BALANCE: 'Daily balance',
      LAST_TRANSACTION_BALANCE: 'Last movement balance',
    },
  },
};
